<template>
	<section class="main-content">
		<div class="row">
			<slot>
				<div class="columns column12 align-center">
					<h2 v-if="subtitle" class="subtitle">{{ subtitle }}</h2>
					<h1>{{ title }}</h1>
					<slot name="extra-heading" />
					<div v-parse-links v-html="content" />
					<slot name="extra-content" />
				</div>
			</slot>
		</div>
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.main-content {
	overflow: hidden;
	background: var(--primary-background-color);

	.subtitle {
		justify-content: center;

		&::after {
			content: '';
			display: block;
			width: 30px;
			height: 1px;
			background-color: #122d1d;
			position: relative;
			flex-shrink: 0;
		}
	}

	:deep(p) {
		font-size: 18px;
		line-height: 34px;
	}
}

@media (max-width: 1480px) {
	:deep(p) {
		font-size: 16px !important;
		line-height: 30px;
	}
}

@media (max-width: 880px) {
	.main-content {
		padding: 40px 0;

		:deep(p) {
			line-height: 28px;
		}
	}

	.intro {
		padding: 50px 0;
	}
}
</style>
